"use client";

import { memo } from "react";
import { Hash, Lock, MessageSquare } from "lucide-react";
import type { ChannelDetail } from "@/lib/types/channel";

type Props = {
  channel: ChannelDetail;
};

function ChannelWelcome({ channel }: Props) {
  return (
    <div className="px-5 pb-4 pt-6">
      <div className="mb-3 flex h-16 w-16 items-center justify-center rounded-lg bg-secondary">
        {channel.emoji ? (
          <span className="text-3xl leading-none">{channel.emoji}</span>
        ) : (
          <MessageSquare className="h-8 w-8 text-muted-foreground" />
        )}
      </div>

      <div className="flex items-center gap-2">
        <h2 className="text-xl font-bold text-foreground">
          {channel.name}
        </h2>
        {channel.type === "PRIVATE" && (
          <Lock className="h-4 w-4 text-muted-foreground" />
        )}
      </div>

      <p className="mt-1 text-sm text-muted-foreground">
        {channel.description
          ? channel.description
          : channel.type === "PRIVATE"
            ? `This is the beginning of the private channel #${channel.name}.`
            : `This is the beginning of #${channel.name}. Send a message to start the conversation.`}
      </p>
    </div>
  );
}

export default memo(ChannelWelcome);
